/*
=========================================================
* Material Kit 2 React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
// Material Kit 2 React examples
// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";
import bgImage from "assets/images/cover/bg-sign-in-basic.jpeg";
// Images

function Mission() {
  return (
    <MKBox
      component="section"
      variant="gradient"
      bgColor="dark"
      position="relative"
      py={6}
      my={3}
      px={{ xs: 2, lg: 0 }}
      mx={-2}
      sx={{
        backgroundImage: ({ functions: { linearGradient, rgba }, palette: { gradients } }) =>
          `${linearGradient(
            rgba(gradients.dark.main, 0.5),
            rgba(gradients.dark.state, 0.9)
          )}, url(${bgImage})`,
        backgroundSize: "contain",
        backgroundPosition: "center",
        display: "grid",
        placeItems: "center",
      }}
    >
      <Container>
        <Grid container>
          <Grid item xs={12} md={6} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              VISION
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              Our vision is to become one of the leading professional production houses in
              Indonesia, where creative ideas meet cutting-edge technology to produce impactful and
              inspiring works
            </MKTypography>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12} md={6} sx={{ mb: 6 }}>
            <MKTypography variant="h3" color="white">
              MISSION
            </MKTypography>
            <MKTypography variant="body2" color="white" opacity={0.8}>
              Our mission is to create with heart—consistently striving to blend smart creativity
              with the latest technology, ensuring every piece we produce stays relevant with
              current trends and delivers meaningful impact to its audience.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default Mission;
